export enum TypeOfLabour {
    Induced = 1,
    Spontaneous = 2
  }